// Interruttore unico per l'identita' "BETA LAUNCH".
// Quando true: banner landing (Landing.beta), box BETA nella sezione Piano
// (Landing.pricingTeaser.betaNote) e avviso in cima al signup (Auth.signup.betaNotice).
// Quando false: landing e registrazione tornano allo standard.
// Lo step 'pending' del signup resta legato allo status del workspace, non a questo flag.
// 2026-08-29: spento con l'arrivo del prezzo (100 AUD/mese, 14 giorni di prova).
// La landing non chiede piu' una candidatura alla beta, il piano ha un prezzo vero.
export const BETA_LAUNCH = false;
